import { Component, Input, OnInit } from "@angular/core";
import { TranscoderJobViewModel } from "../../transcoder-job-view.model";
import { MediaTranscoderHistoryViewModel } from "../history.view-model";

@Component({
  selector: "evrideo-transcoding-job-report",
  templateUrl: "./transcoding-job-report.component.html",
  styleUrls: ["./transcoding-job-report.component.scss"],
})
export class TranscodingJobReportComponent implements OnInit {
  @Input()
  vm: MediaTranscoderHistoryViewModel;

  @Input()
  loadingMessage = 'Retrieving transcoding job report. Please wait.';

  constructor() {}

  ngOnInit() {}
}
